import { render, staticRenderFns } from "./VueAceEditor.vue?vue&type=template&id=4af6ed29&scoped=true&"
import script from "./VueAceEditor.vue?vue&type=script&lang=js&"
export * from "./VueAceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af6ed29",
  null
  
)

export default component.exports